import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Loader from "react-loader-spinner";
import PhoneInput from "react-phone-input-2";

import { useTranslation } from "react-i18next";
import { getLocaleValue } from "../../utils";
import { toastMessage } from "../../utils/toast";
import { clearSession } from "../../utils/initiate";
import * as userActions from "../../Redux/Actions/user";
import UserAccountDeleteModal from "../Ui/UserAccountDeleteModal/UserAccountDeleteModal";
import NeedHelpModal from "../Ui/NeedHelpModal/NeedHelpModal";

const Setting = ({ history }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [errMsg, setErrMsg] = useState("");
  const [firstName, setFirstName] = useState("");
  const [firstNameEMsg, setFirstNameEMsg] = useState("");
  const [lastNameEMsg, setLastNameEMsg] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [button2Loading, setButton2Loading] = useState("");
  const [loading, setLoading] = useState(false);
  const [lastName, setLastName] = useState("");
  const [number, setNumber] = useState("");
  const [title, setTitle] = useState("");
  const [countryCode, setCountryCode] = useState("");
  // const [OTP, setOTP] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [button5Loading, setButton5Loading] = useState("");
  const [showChatModal, setShowChatModal] = useState(false);

  const userData = useSelector(({ User }) => User.data);

  useEffect(() => {
    setLoading(true);
    userActions
      .getUser(userData.UserId)
      .then((res) => {
        if (res && res.data) {
          let data = res.data.data;
          setEmail(data.email);
          setMobileNumber(data.mobileNumber);
          setTitle(data.title);
          setFirstName(data.name);
          let code = data.countryCode;
          let result = code.slice(1);
          let fullNumber = result + data.mobileNumber;
          setNumber(fullNumber);
          setCountryCode(result);
          setCountryCode(data.countryCode);
          setLastName(data.lastName);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        err?.response?.status === 401 && clearSession(dispatch, history);
      });
  }, []);

  const handleOk = () => {
    setButton2Loading(true);
    if (
      firstName !== "" &&
      lastName !== "" &&
      email !== "" &&
      mobileNumber !== "" &&
      countryCode !== "" &&
      title !== ""
      // && OTP !== ""
    ) {
      if (firstNameEMsg == "" && lastNameEMsg == "") {
        const payload = {
          id: userData.UserId,
          title: title,
          name: firstName,
          lastName,
          email,
          // otp: OTP,
          mobileNumber,
          countryCode: `+${countryCode}`,
        };

        userActions
          .userUpdate(payload)
          .then((res) => {
            if (res && res.status === 200) {
              toastMessage("success", "User Profile Updated Successfully");
              window.location.reload();
              setButton2Loading(false);
            } else if (res && res.status === 400) {
              setButton2Loading(false);
              toastMessage("error", "Profile Not Updated");
              history.push(`/`);
            } else {
              setButton2Loading(false);
              toastMessage("error", " Error Ocurred ");
            }
          })
          .catch((err) => {
            if (err?.response?.statusCode == 401) {
              toastMessage("error", "Access Denied");
            } else {
              toastMessage("error", err?.response?.data?.title);
            }
            setButton2Loading(false);
          });
      } else {
        setButton2Loading(false);
      }
    } else {
      setErrMsg("Please fill all the fields");
      setButton2Loading(false);
    }
  };

  const handleOnChange = (value, data) => {
    setCountryCode(data.dialCode);
    let val = value.slice(data.dialCode.length);
    setMobileNumber(val);
    val.length < 8 && val.length > 0
      ? setErrMsg("Phone Number must be of atleast 8 digit")
      : setErrMsg("");
  };

  const handleDeleteModalClose = () => {
    setShowDeleteModal(false);
    setButton5Loading(false);
  };

  // const handleOTP = () => {
  //   setButton1Loading(true);
  //   if (email !== "") {
  //     const payload = {
  //       userName: email,
  //     };

  //     userActions
  //       .sendOTP(payload)
  //       .then((res) => {
  //         if (res && res.status === 200) {
  //           toastMessage(
  //             "success",
  //             "OTP send to your Registered Email Successfully"
  //           );
  //           setButton1Loading(false);
  //         } else {
  //           toastMessage("error", "Enter Correct Email ID");
  //         }
  //       })
  //       .catch((err) => {
  //         toastMessage("error", "Enter Correct Email Id");
  //         setButton1Loading(false);
  //       });
  //   } else {
  //     setErrMsg("Please enter Email Address");
  //     setButton1Loading(false);
  //   }
  // };

  return (
    <>
      <div className="card-body pb-3 ">
        <div style={{ textAlign: "center" }}>
          <div>
            <span
              style={{
                fontSize: "30px",
                fontWeight: "500",
                borderBottom: "2px solid #b71c1c",
                display: "inline-block",
                marginBottom: "2%",
              }}
            >
              {getLocaleValue("settings")}
            </span>
          </div>
        </div>
        {loading ? (
          <Loader
            type="ThreeDots"
            color="#ad1a5f"
            height={40}
            width={40}
            style={{ textAlign: "center", marginBottom: "50px" }}
          />
        ) : (
          <div className="d-flex mt-2 justify-content-center">
            <div className="col-lg-6 card justify-content-center">
              <div className="card-body form-group fv-plugins-icon-container col-md-12 col-sm-6">
                <div className="d-flex align-items-center my-1">
                  <label className="p-3 form-label col-md-4 col-sm-2">
                    {getLocaleValue("usr_profile_title")}
                  </label>

                  <select
                    className="form-select col-md-4 col-sm-2"
                    value={title}
                    onChange={(e) => {
                      setTitle(e.target.value);
                    }}
                    style={{ width: "50%", height: "35px" }}
                  >
                    <option value="" disabled={true}>
                      Select Title
                    </option>
                    <option value="mr">Mr.</option>
                    <option value="mrs">Mrs.</option>
                    <option value="major">Major</option>
                    <option value="dr">Dr.</option>
                  </select>
                </div>
                <div className="d-flex align-items-center">
                  <label className="p-3 form-label col-md-4 col-sm-2">
                    {getLocaleValue("usr_profile_firstName")}
                  </label>
                  <input
                    type="text"
                    className="p-1 form-control col-md-4 col-sm-2"
                    required={true}
                    style={{ width: "50%", height: "30px" }}
                    placeholder="Enter First Name"
                    value={firstName}
                    onChange={(e) => {
                      const re = /^[a-zA-Z0-9_ ]*$/;
                      if (e.target.value === "" || re.test(e.target.value)) {
                        setFirstName(e.target.value);
                      }
                      setErrMsg("");
                      e.target.value.length > 25
                        ? setFirstNameEMsg("First name should be maximum 25")
                        : setFirstNameEMsg("");
                      setErrMsg("");
                    }}
                  ></input>
                </div>
                {firstNameEMsg && (
                  <p className="text-danger mt-2 text-center font-weight-bold font-15">
                    {firstNameEMsg}
                  </p>
                )}
                <div className="d-flex align-items-center">
                  <label className="p-3 form-label col-md-4 col-sm-2">
                    {getLocaleValue("usr_profile_lastName")}
                  </label>
                  <input
                    type="text"
                    className="p-1 form-control col-md-4 col-sm-2"
                    required={true}
                    style={{ width: "50%", height: "30px" }}
                    placeholder="Enter Last Name"
                    value={lastName}
                    onChange={(e) => {
                      const re = /^[a-zA-Z0-9_ ]*$/;
                      if (e.target.value === "" || re.test(e.target.value)) {
                        setLastName(e.target.value);
                      }
                      setErrMsg("");
                      e.target.value.length > 25
                        ? setLastNameEMsg("Last name should be maximum 25")
                        : setLastNameEMsg("");
                      setErrMsg("");
                    }}
                  ></input>
                </div>
                {lastNameEMsg && (
                  <p className="text-danger mt-2 text-center font-weight-bold font-15">
                    {lastNameEMsg}
                  </p>
                )}
                <div className="d-flex align-items-center">
                  <label className="p-3 form-label col-md-4 col-sm-2">
                    {getLocaleValue("signup_email")}
                  </label>
                  <input
                    type="email"
                    className="p-1 form-control col-md-4 col-sm-2"
                    required={true}
                    style={{ width: "50%", height: "30px" }}
                    placeholder="Enter Email ID"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setErrMsg("");
                    }}
                    disabled={true}
                  ></input>
                </div>
                <div className="d-flex align-items-center">
                  <label className="p-3 form-label col-md-4 col-sm-2">
                    {getLocaleValue("signup_phone_number")}
                  </label>
                  <div>
                    <PhoneInput
                      country={"ae"}
                      countryCodeEditable={false}
                      placeholder={"Enter Mobile Number"}
                      onChange={handleOnChange}
                      required={true}
                      value={number}
                      containerClass="col-sm-1 col-md-2"
                      disabled={true}
                    />
                  </div>
                </div>
                {/* <div className="d-flex align-items-center">
                <label className="p-3 form-label col-md-4 col-sm-2">
                  {getLocaleValue("login_otp")}
                </label>
                <input
                  type="email"
                  className="p-1 form-control"
                  required={true}
                  style={{ width: "50%", height: "30px" }}
                  placeholder="Enter OTP"
                  onChange={(e) => {
                    setOTP(e.target.value);
                    setErrMsg("");
                  }}
                ></input>
                {
                  <button
                    type="button"
                    className="btn btn-primary font-weight-bold d-flex align-items-center"
                    onClick={handleOTP}
                    disabled={button1Loading}
                    style={{ marginLeft: "20px" }}
                  >
                    {getLocaleValue("get_otp_btn")}
                    {button1Loading && (
                      <Loader type="Oval" color="#fff" height={20} width={20} />
                    )}
                  </button>
                }
              </div> */}

                {errMsg && (
                  <p
                    className="text-danger "
                    style={{ marginTop: "15px", marginBottom: "15px" }}
                  >
                    {errMsg}
                  </p>
                )}

                <div
                  style={{
                    display: "flex",
                    marginBottom: "20px",
                    marginTop: "30px",
                  }}
                >
                  {
                    <button
                      type="button"
                      className="btn btn-primary font-weight-bold d-flex align-items-center"
                      onClick={handleOk}
                      disabled={button2Loading}
                    >
                      {t("update")}
                      {button2Loading && (
                        <Loader
                          type="Oval"
                          color="#fff"
                          height={20}
                          width={20}
                          style={{ marginLeft: "10px" }}
                        />
                      )}
                    </button>
                  }
                </div>
                <div style={{ marginTop: "20px" }}>
                  <div className="form-group mb-0 row">
                    <div className="col-12" style={{ width: "150px" }}>
                      <button
                        className="btn btn-primary w-100 waves-effect waves-light d-flex align-items-center justify-content-center"
                        type="button"
                        disabled={button5Loading}
                        onClick={() => {
                          setShowDeleteModal(true);
                          setButton5Loading(true);
                        }}
                      >
                        {getLocaleValue("profile_account_delete")}{" "}
                        {button5Loading && (
                          <Loader
                            type="Oval"
                            color="#fff"
                            height={20}
                            width={20}
                            style={{ marginLeft: "10px" }}
                          />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}{" "}
        <div className="d-flex justify-content-center">
          <div className="col-md-6">
            <div className="d-flex space-between">
              {
               !loading && <button
                  type="button"
                  className="btn btn-primary font-weight-bold d-flex align-items-center"
                  onClick={() => {
                    setShowChatModal(true);
                  }}
                  style={{ marginLeft: "15px" }}
                >
                  {"Chat ?"}{" "}
                </button>
              }
            </div>
          </div>
        </div>
      </div>

      {showDeleteModal && (
        <UserAccountDeleteModal
          handleCancel={handleDeleteModalClose}
          history={history}
          showModal={showDeleteModal}
          footerOption1={getLocaleValue("delete_account_btn")}
          footerOption2={getLocaleValue("delete_cancel_btn")}
          type={"delete"}
        >
          {" "}
        </UserAccountDeleteModal>
      )}
      {showChatModal && (
        <NeedHelpModal
          t={t}
          handleCancel={() => {
            setShowChatModal(false);
          }}
          showModal={showChatModal}
          footerOption1={"Submit"}
          footerOption2={"Cancel"}
          type={"chat"}
        >
          {" "}
        </NeedHelpModal>
      )}
    </>
  );
};

export default Setting;
